import { EquipmentFormValue } from '../types';

export function prepareCreateUpdateEquipmentDTO(formData: EquipmentFormValue) {
  const { commonInfo, attachments } = formData;

  return {
    attachments,
    year: commonInfo.year,
    make: commonInfo.make,
    model: commonInfo.model,
    mileage: commonInfo.mileage,
    stockId: commonInfo.stockId,
    quantity: commonInfo.quantity,
    classType: commonInfo.class,
    truckClass: parseInt(commonInfo.class?.replace(/\D/g, '') ?? '', 10) ?? null,
    newUsed: commonInfo.condition,
    wholesaleCost: commonInfo.saleCost,
    retailPrice: commonInfo.retailPrice,
    serialNumberVin: commonInfo?.vin?.trim(),
    totalWholesaleCost: commonInfo.wholeSaleCost,
    additionalDescription: commonInfo.description,
    inventoryItem: {
      status: commonInfo.inventoryItem.status,
    },
  };
}
